import crownUrl from '../../../shared/assets/icon/crown.svg';
import moneyUrl from '../../../shared/assets/icon/money.svg';
import copyUrl from '../../../shared/assets/icon/copy.svg';
import { useToast } from '../../contexts/ToastContext';

const PromoDetails = () => {
  const { notify } = useToast();

  const handleCopy = () => {
    navigator.clipboard
      .writeText('SHILO')
      .then(() => {
        notify(
          'default',
          'Промокод скопирован',
          'Воспользуйтесь им в игре, чтобы получить бонусы!',
          'bottom-right'
        );
      })
      .catch(() => {
        notify(
          'default',
          'Ошибка копирования',
          'Не удалось скопировать промокод. ',
          'bottom-right'
        );
      });
  };

  return (
    <section className="content__details" aria-label="Детали бонуса">
      <div className="content__details-paragraphs">
        <dl className="content__details-paragraph">
          <dt className="detail__prize">
            <img
              className="detail__prize-icon"
              src={crownUrl}
              alt=""
              aria-hidden="true"
            />
            <span className="detail__prize-text">Majestic Премиум</span>
          </dt>
          <dd className="detail__text">на 7 дней</dd>
        </dl>
        <dl className="content__details-paragraph">
          <dt className="detail__prize">
            <img
              className="detail__prize-icon"
              src={moneyUrl}
              alt=""
              aria-hidden="true"
            />
            <strong className="detail__prize-text">50 000</strong>
          </dt>
          <dd className="detail__text">игровой валюты</dd>
        </dl>
      </div>
      <div className="detail__promo">
        <span className="detail__promo-text">Промокод:</span>
        <span className="detail__promo-separator" aria-hidden="true"></span>
        <code className="detail__promo-code">SHILO</code>
        <button
          className="detail__promo-copy"
          onClick={handleCopy}
          aria-label="Скопировать промокод SHILO"
        >
          <img
            className="detail__promo-copy-icon"
            src={copyUrl}
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>
    </section>
  );
};

export default PromoDetails;
